import React from "react";

const PrivacyPolicy = () => {
  return (
    <div id="privacypolicy" className="section no-padding">
      <div className="the_content_wrapper ">
        <div className="header">Privacy Policy</div> <br/>
        <p className="p1">
          <span className="s1">
            <b>By Using Our Webite You Accept this Privacy Policy </b>
          </span>
        </p>
        <p className="p1">
          <span className="s1">
            <b>
              Please read this Privacy Policy carefully and ensure that you
              understand it. Your acceptance of this Privacy Policy is deemed
              given every time you use Our Site.
            </b>
          </span>
        </p>
        <p className="p3">
          <span className="s1">
            We understand that your privacy is important to you and that you
            care about how your personal data is used. We respect and value the
            privacy of everyone who visits this website, nomo.app or its
            equivalent version on Android, iOS or other operating system, kernel
            or software environment that we make available to you or the public
            from time to time (
          </span>
          <span className="s2">
            <b>“Our Site”</b>
          </span>
          <span className="s1">
            ) and will only collect and use personal data in ways that are
            described here, and in a way that is consistent with our obligations
            and your rights under the law.
          </span>
        </p>
        <ol className="ol1">
          <li className="li4 margin">
            <span className="s1">
              <b>Definitions and Interpretation</b>
            </span>
          </li>
        </ol>
        <p className="p5">
          <span className="s1">
            In this Policy the following terms shall have the following
            meanings:&nbsp;
          </span>
        </p>
        <table className="t1 margin" cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <td className="td1" valign="top">
                <p className="p7">
                  <span className="s1">
                    <b>“We/Us/Our”</b>
                  </span>
                </p>
              </td>
              <td className="td2" valign="top">
                <p className="p9">
                  <span className="s1">means Nomo Digital Ltd</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="td3" valign="top">
                <p className="p7">
                  <span className="s1">
                    <b>“Account”</b>
                  </span>
                </p>
              </td>
              <td className="td4" valign="top">
                <p className="p8">
                  <span className="s1">
                    means an account required to access and/or use certain areas
                    and features of Our Site;
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="td5" valign="top">
                <p className="p7">
                  <span className="s1">
                    <b>“Cookie”</b>
                  </span>
                </p>
              </td>
              <td className="td6" valign="top">
                <p className="p8">
                  <span className="s1">
                    means a small text file placed on your computer or device by
                    Our Site when you visit certain parts of Our Site and/or
                    when you use certain features of Our Site. Details of the
                    Cookies used by Our Site are set out below.
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <ol className="ol1">
          <li className="li4 margin">
            <span className="s1">
              <b>What Does This Policy Cover?</b>
            </span>
          </li>
        </ol>
        <p className="p9">
          <span className="s1">
            This Privacy Policy applies only to your use of Our Site, which is
            operated by us. Our Site may contain links to other websites. Please
            note that we have no control over how your data is collected,
            stored, or used by other websites and we advise you to check the
            privacy policies of any such websites before providing any data to
            them.
          </span>
        </p>
        <ol className="ol1">
          <li className="li4 margin">
            <span className="s1">
              <b>What Is Personal Data?</b>
            </span>
          </li>
        </ol>
        <p className="p9">
          <span className="s1">
            Personal data is, in simple terms, any information about you that
            enables you to be identified. Personal data covers obvious
            information such as your name and contact details, but it also
            covers less obvious information such as identification numbers,
            electronic location data, and other online identifiers.
          </span>
        </p>
        <ol className="ol1">
          <li className="li4 margin">
            <span className="s1">
              <b>What Are My Rights?</b>
            </span>
          </li>
        </ol>
        <p className="p5">
          <span className="s1">
            Under this Privacy Policy, you have the following rights, which we
            will always work to uphold:
          </span>
        </p>
        <ol className="ol1">
          <li style={{ listStyleType: "none" }}>
            <ol className="ol1">
              <li style={{ listStyleType: "none" }}>
                <ol className="ol1">
                  <li style={{ listStyleType: "none" }}>
                    <ol className="ol2">
                      <li className="li10">
                        <span className="s1">
                          The right to be informed about Our collection and use
                          of your personal data. This Privacy Policy should tell
                          you everything you need to know, but you can always
                          contact us to find out more or to ask any questions
                          using the details given below.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to access the personal data we hold about
                          you.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to have your personal data rectified if any
                          of your personal data held by us is inaccurate or
                          incomplete.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to be forgotten, i.e., the right to ask us
                          to delete or otherwise dispose of any of your personal
                          data that we hold.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to restrict (i.e. prevent) the processing of
                          your personal data.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to object to us using your personal data for
                          a particular purpose or purposes.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to withdraw consent. This means that, if we
                          are relying on your consent as the legal basis for
                          using your personal data, you are free to withdraw
                          that consent at any time.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          The right to data portability. This means that, if you
                          have provided personal data to us directly, we are
                          using it with your consent or for the performance of a
                          contract, and that data is processed using automated
                          means, you can ask us for a copy of that personal data
                          to re-use with another service or business in many
                          cases.
                        </span>
                      </li>
                      <li className="li10">
                        <span className="s1">
                          Rights relating to automated decision-making and
                          profiling.{" "}
                        </span>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
        <p className="p5">
          <span className="s1">
            For more information about Our use of your personal data or
            exercising your rights as outlined above, please contact us using
            the details provided below.
          </span>
        </p>
        <p className="p5">
          <span className="s1">
            It is important that your personal data is kept accurate and
            up-to-date. If any of the personal data we hold about you changes,
            please keep us informed as long as we have that data.
          </span>
        </p>
        <p className="p5">
          <span className="s1">
            Further information about your rights can also be obtained from the
            Information Commissioner’s Office or your local Citizens Advice
            Bureau.
          </span>
        </p>
        <p className="p5">
          <span className="s1">
            If you have any cause for complaint about Our use of your personal
            data, you have the right to lodge a complaint with our customer care
            team at support@nomo.app. We would welcome the opportunity to
            resolve your concerns ourselves so please contact us using the
            details given below.
          </span>
        </p>
        <ol className="ol1">
          <li className="li1 margin">
            <span className="s2">
              <b>How Do You Use Cookies?</b>
            </span>
          </li>
        </ol>
        <p className="p2">
          <span className="s2">
            Our Site may place and access certain first-party Cookies on your
            computer or device. First-party Cookies are those placed directly by
            us and are used only by Us. We use Cookies to facilitate and improve
            your experience of Our Site and to provide and improve Our products
            or services. We have carefully chosen these Cookies and have taken
            steps to ensure that your privacy and personal data is protected and
            respected at all times.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            By using Our Site, you may also receive certain third-party Cookies
            on your computer or device. Third-party Cookies are those placed by
            websites, services, and/or parties other than Us. Third-party
            Cookies are used on Our Site for Google Analytics. For more details,
            please refer to the table below. These Cookies are not integral to
            the functioning of Our Site and your use and experience of Our Site
            will not be impaired by refusing consent to them.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            All Cookies used by and on Our Site are used in accordance with
            current Law.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            Before Cookies are placed on your computer or device, you will be
            shown a popup requesting your consent to set those Cookies. By
            giving your consent to the placing of Cookies you are enabling us to
            provide the best possible experience and service to you. You may, if
            you wish, deny consent to the placing of Cookies; however certain
            features of Our Site may not function fully or as intended. You will
            be given the opportunity to allow only first-party Cookies and block
            third-party Cookies.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            In addition to the controls that we provide, you can choose to
            enable or disable Cookies in your internet browser. Most internet
            browsers also enable you to choose whether you wish to disable all
            Cookies or only third-party Cookies. By default, most internet
            browsers accept Cookies, but this can be changed. For further
            details, please consult the help menu in your internet browser or
            the documentation that came with your device.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            You can choose to delete Cookies on your computer or device at any
            time, however you may lose any information that enables you to
            access Our Site more quickly and efficiently including, but not
            limited to, login and personalisation settings.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            It is recommended that you keep your internet browser and operating
            system up-to-date and that you consult the help and guidance
            provided by the developer of your internet browser and manufacturer
            of your computer or device if you are unsure about adjusting your
            privacy settings.
          </span>
        </p>
        <p className="p3">
          <span className="s2">
            Our Site may place and access certain first-party Cookies on your
            computer or device. First-party Cookies are those placed directly by
            us and are used only by us. We use Cookies to facilitate and improve
            your experience of Our Site and to provide and improve Our products
            services. By using Our Site you may also receive certain third-party
            Cookies on your computer or device. Third-party Cookies are those
            placed by websites, services, and/or parties other than us.{" "}
          </span>
        </p>
        <ol className="ol1">
          <li className="li1 margin">
            <span className="s2">
              <b>How Do I Contact You?</b>
            </span>
          </li>
        </ol>
        <p className="p3">
          <span className="s2">
            To contact us about anything to do with your personal data and data
            protection, including to make a subject access request, please send
            us an email to support@nomo.app or a written request per post to our
            office address given above.
          </span>
        </p>
        <ol className="ol1">
          <li className="li1 margin">
            <span className="s2">
              <b>Changes to this Privacy Policy</b>
            </span>
          </li>
        </ol>
        <p className="p2">
          <span className="s2">
            We may change this Privacy Notice from time to time. This may be
            necessary, for example, if the law changes, or if we change Our
            business in a way that affects personal data protection.
          </span>
        </p>
        <p className="p2">
          <span className="s2">
            Any changes will be immediately posted on Our Site and you will be
            deemed to have accepted the terms of the Privacy Policy on your
            first use of Our Site following the alterations. We recommend that
            you check this page regularly to keep up-to-date.
          </span>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
